import qs from 'qs'

interface Params {
  url: string
}

const getQueryParams = ({ url }: Params) => {
  const parsedSearch = qs.parse(url, {
    ignoreQueryPrefix: true,
  }) as Record<string, string>

  return parsedSearch
}

export default getQueryParams
